
<template>
  <div v-if="data" v-wechat-title="title">
    <div class="groupRectBase">
      <div class="title" :style="'background-color: '+data.team.baseColor+';color:'+data.team.fontColor">购买方式
        <div class="topButton"><i class="iconfont iconback" @click="onBack" /></div>
      </div>
      <div class="about">
        <div class="buttonRect" :style="'background-color: '+data.team.baseColor+';color:'+data.team.fontColor" @click="onBuy">
          <van-row>
            <van-col span="20">
              {{ selectCommodity.priceBase.toFixed(2) }}元{{ selectCommodity.freightType==='FREE'?'包邮':"" }}，付款购买
            </van-col>
            <van-col span="4" class="rigth"><i class="iconfont iconrigthjt rigthJt" /></van-col>
          </van-row>
        </div>
        <div v-if="isGroupBuy && !joinTeamId" class="buttonRect" :style="'background-color: '+data.team.baseColor+';color:'+data.team.fontColor" @click="onCreateTeam">
          <van-row>
            <van-col span="20">{{ selectCommodity.price===0?"免费获取":selectCommodity.price.toFixed(2)+"元团购" }}！寻找潜伴组队</van-col>
            <van-col span="4" class="rigth"><i class="iconfont iconrigthjt rigthJt" /></van-col>
          </van-row>
        </div>
        <div v-if="isGroupBuy && joinTeamId" class="buttonRect" :style="'background-color: '+data.team.baseColor+';color:'+data.team.fontColor" @click="onJoinTeam">
          <van-row>
            <van-col span="20">{{ selectCommodity.price===0?"免费获取":selectCommodity.price.toFixed(2)+"元团购" }}！加入潜伴队伍</van-col>
            <van-col span="4" class="rigth"><i class="iconfont iconrigthjt rigthJt" /></van-col>
          </van-row>
        </div>
        <div v-if="isCodeBuy" class="buttonRectInput" :style="'border: 2px solid '+data.team.baseColor+';color:'+data.team.baseColor" @click="onUseCode">
          <div v-if="showCode" class="codeRect">
            <van-field v-model="code" placeholder="请输入活动代码" style="padding:0;" />
          </div>
          <div v-if="!showCode" class="codeRect">
            输入活动代码{{ selectCommodity.price===0?"免费获取":selectCommodity.price.toFixed(2)+"元团购" }}！
          </div>
          <div class="rigthButton">
            <i v-if="code.length <= 0" class="iconfont iconrigthjt rigthJt" />
            <div v-if="code.length > 0" class="codeButton" :style="'background-color: '+data.team.baseColor+';color:'+data.team.fontColor" @click="onCode">完成</div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Toast, Dialog, Field, Button } from 'vant'
import { getUrlKey, MyNotify } from '@/utils/base'
import Cookies from 'js-cookie'
export default {
  components: {
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Field.name]: Field
  },
  data() {
    return {
      title: '团购活动',
      backurl: '/store/index',
      key: undefined,
      data: undefined,
      commodityId: undefined,
      addressId: undefined,
      certificateId: undefined,
      selectCommodity: undefined,
      groupTeam: undefined,
      joinTeamId: undefined,
      nickName: undefined,
      showCode: undefined,
      code: '',
      isGroupBuy: false,
      isCodeBuy: false
    }
  },

  created() {
    this.key = this.$route.params.key
    this.commodityId = getUrlKey('commodity')
    this.addressId = getUrlKey('address')
    this.certificateId = getUrlKey('certificate')
    this.groupTeam = getUrlKey('team')
    this.joinTeamId = Cookies.get('groupKey_')
    this.nickName = Cookies.get('GroupNickName_')
    this.init()
  },
  methods: {
    init() {
      request({
        url: '/StoreHelper/getGroupBuy',
        method: 'get',
        params: { key: this.key }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.isGroupBuy = this.data.team.isGroupTeamBuy
        this.isCodeBuy = this.data.team.isCodeBuy
        this.title = this.data.team.shortName
        this.data.commodity.forEach(item => {
          if (item.groupBuyCommodityId === this.commodityId) {
            this.selectCommodity = item
          }
        })
      })
    },
    onBack() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/group/groupAddress/' + this.key)
    },
    onBuy() {
      var otherIds = ''
      var diyData = {
        title: this.nickName,
        nickName: this.nickName,
        certificateId: this.certificateId,
        certificateTeam: this.groupTeam
      }
      var data = this.selectCommodity.commodityId + '|1|' + this.selectCommodity.specificationId + '|' + otherIds + '|' + JSON.stringify(diyData) + '||||'
      this.$router.push('/store/ordercreate?data=' + data)
    },
    onCreateTeam() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '创建队伍中'
      })
      this.createTeam()
      // this.$router.push('/group/groupCommodity/' + this.key + '?commodity=' + this.commodityId
      // )
    },
    onJoinTeam() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加入队伍中'
      })
      request({
        url: '/StoreHelper/joinGroupBuy',
        method: 'post',
        data: {
          key: this.key,
          AddressId: this.addressId,
          groupTeam: this.groupTeam,
          certificateId: this.certificateId,
          groupCommodityId: this.commodityId,
          teamCode: this.joinTeamId,
          nickName: this.nickName
        }
      }).then(response => {
        Toast.clear()
        if (!response.success) {
          return
        }
        if (response.data.isIn) {
          this.$router.push('/group/team/' + response.data.teamCode)
          return
        }
        if (response.data.inAnotherTeam) {
          console.log('在其他人的队伍中')
          Dialog.confirm({
            title: '已加入队伍',
            message: '您已经在其他队伍中了，不能重复创建，是否查看？'
          }).then(() => {
            this.$router.push('/group/team/' + response.data.teamCode)
            return
          })
        }
        if (response.data.isFull) {
          Dialog.confirm({
            title: '队伍满员',
            message: '您要加入的队伍已经满员，是否创建一个新队伍?'
          }).then(() => {
            this.onCreateTeam()
          })
          return
        }
        MyNotify('success', '加入成功')
        this.$router.push('/group/team/' + response.data.teamCode)
      })
    },
    createTeam() {
      request({
        url: '/StoreHelper/createGroupBuy',
        method: 'post',
        data: {
          key: this.key,
          AddressId: this.addressId,
          groupTeam: this.groupTeam,
          certificateId: this.certificateId,
          groupCommodityId: this.commodityId,
          nickName: this.nickName
        }
      }).then(response => {
        Toast.clear()
        if (!response.success) {
          return
        }
        if (response.data.inAnotherTeam) {
          console.log('在其他人的队伍中')
          Dialog.confirm({
            title: '已加入队伍',
            message: '您已经在其他队伍中了，不能重复创建，是否查看？'
          }).then(() => {
            this.$router.push('/group/team/' + response.data.teamCode)
            return
          })
        } else {
          MyNotify('success', '创建成功')
          this.$router.push('/group/team/' + response.data.teamCode)
          return
        }
      })
    },
    onUseCode() {
      this.showCode = true
    },
    onCode() {
      Dialog.confirm({
        title: '活动代码使用说明',
        message: '每个活动代码只能购买一次，如订单信息错误，可取消订单后重新使用活动代码下单，是否现在下单？'
      }).then(() => {
        this.onCodeDo()
      })
    },
    onCodeDo() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '正在核验活动代码中，请稍后'
      })
      request({
        url: '/StoreHelper/groupBuyCreateOrderByCode',
        method: 'post',
        data: {
          key: this.key,
          AddressId: this.addressId,
          groupTeam: this.groupTeam,
          certificateId: this.certificateId,
          groupCommodityId: this.commodityId,
          nickName: this.nickName,
          code: this.code
        }
      }).then(response => {
        Toast.clear()
        if (!response.success) {
          return
        }
        if (response.data.isNewOrder) {
          this.$router.push('/store/order/' + response.data.orderId)
          return
        }
        Dialog.confirm({
          title: '检查到相关订单',
          message: '检查到您有相关订单，是否前往查看？如需重新下单，请取消相关订单即可！'
        }).then(() => {
          this.$router.push('/store/order/' + response.data.orderId)
        })
      })
    }
  }
}
</script>
<style scoped>
.buttonRect{
  font-weight: 700;
  padding: 0.7em 1em;
  margin: 1em;
  border: 1px solid #ccc;
  border-radius: 0.4em;
}
.buttonRectInput{
  font-weight: 700;
  padding-left:1em;
  margin: 1em;
  border: 1px solid #ccc;
  border-radius: 0.4em;
  position: relative;
}
.buttonRectInput .codeRect{
  margin: 0.5em 0;
  width: 72%;
}
.buttonRectInput .rigthButton{
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  left: 75%;
}
.buttonRectInput .rigthButton .rigthJt
{
  position: absolute;
  right: 1em;
  top: 50%;
  transform: translateY(-50%);
}
.rigthJt{
  color: #ccc;
}
.codeButton{
  text-align: center;
  margin:3%;
  height: 88%;
  border-radius: 0.4em;
  line-height: 36px;
}
</style>
